/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

// Styles
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
} from '../CreateEvent/style';
import { FormHeading } from '../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { Main } from '../AdminTeamCreation/styles';
import { Layout } from '../EditWellnessJourney/styles';
import { Border } from '../Journeys/styles';
import { ManagerIconContainer } from '../Manager/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import { CommonButtonBorder } from '../common/commonStyles';

// Components
import Editor from '../CKEditor';
import { EditorContainer } from '../EditWellnessJourney/styles';
import CommonImageUploader from '../common/CommonImageUploader/CommonImageUploader';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';

// Utils & Constants
import { ImageUrl, WellnessLevels } from '../../utils/constants';
import { fetchApi, getMonthName } from '../../utils/methods';
import { GetWellnessGoals, GetQuestionByCategoryId, GetArticleCategories, GetWellbeingPillars, AddWellnessJourney } from '../../redux/constants/apiConstants';
import { RecognitionCloseIcon, UploadHDMIcon, closeIcon } from '../../utils/icons';

// Mocking StepsHeading
import StepsHeading from '../../components/RecogntionAdmin/corevalues/stepNames';

// --- Custom Styled Components ---

const CategoryGrid = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
`;

const CategoryChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  border: 0.75px solid ${(props) => (props.active ? '#DA6C74' : '#E0E0E0')};
  background-color: ${(props) => (props.active ? '#DA6C74' : '#FFFFFF')};
  color: ${(props) => (props.active ? '#fff' : '#184A61')};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  font-family: 'Lato', sans-serif;

  &:hover {
    border-color: #DA6C74;
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border-radius:50%;
  }
`;

const AudioUploadBox = styled.div`
  border: 0.75px solid #DCDCDC;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s;
  height: 150px;
  margin-bottom: 8px;
  width: 40%;
  &:hover {
    background-color: #F0F0F0;
  }

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
`;

const AudioFileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 0.75px solid #DCDCDC;
  border-radius: 4px;
  background-color: #FAFAFA;
  margin-bottom: 15px;
  width: 40%;
`;

const FileName = styled.div`
  color: #184A61;
  font-size: 14px;
  font-family: 'Lato', sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

const CloseIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: color 0.2s;

  &:hover {
    color: #DA6C74;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// const StyledTextArea = styled.textarea`
//   width: 100%;
//   min-height: 100px;
//   padding: 12px;
//   border: 0.75px solid #DCDCDC;
//   border-radius: 4px;
//   font-family: 'Lato', sans-serif;
//   font-size: 16px;
//   color: #184A61;
//   resize: vertical;
//   outline: none;
   
//   &::placeholder {
//     color: #BDBDBD;
//   }
// `;

const UploadIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
    <path d="M17.95 5.535 14.465 2.05A6.95 6.95 0 0 0 9.515 0H5a5.004 5.004 0 0 0-5 4.999v14c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5v-8.515c0-1.87-.728-3.626-2.05-4.949m-1.414 1.414c.318.318.587.671.805 1.05H13c-.551 0-1-.449-1-1V2.658c.379.218.733.487 1.05.805l3.485 3.485zM18 18.999c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-14c0-1.654 1.346-3 3-3h4.515q.245 0 .485.023v4.977c0 1.654 1.346 3 3 3h4.977q.023.24.023.485zm-4.293-4.519a.999.999 0 1 1-1.414 1.414L11 14.601v4.398a1 1 0 0 1-2 0v-4.398l-1.293 1.293a.999.999 0 1 1-1.414-1.414l1.614-1.614a2.965 2.965 0 0 1 4.187 0z" fill="#da6c74"/>
  </svg>
);

const CloseIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12.8536 3.14645C13.0488 3.34171 13.0488 3.65829 12.8536 3.85355L8.70711 8L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L8 8.70711L3.85355 12.8536C3.65829 13.0488 3.34171 13.0488 3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464L7.29289 8L3.14645 3.85355C2.95118 3.65829 2.95118 3.34171 3.14645 3.14645C3.34171 2.95118 3.65829 2.95118 3.85355 3.14645L8 7.29289L12.1464 3.14645C12.3417 2.95118 12.6583 2.95118 12.8536 3.14645Z" fill="currentColor"/>
  </svg>
);

class CreateArticleForm extends Component {
  constructor(props) {
    super(props);


    this.state = {
      title:null,
      step: 1,
      imageUpdated: false,
      wellnessGoals: [],
      wbaQuestions: [], // Changed to match old code structure
      showWbaQue: false,
      wellness_goal: null,
      level: null,
      question: null,
      isDisabled: false,
      description: '',
      articleContent: '',
      audio: '',
      audioName: '',
      charCount: 0,
      journey_category_ids: null,
      isLoadingQuestions: false,
      themeOpen: false,
      levelOpen: false,
      goalOpen: false,
      questionOpen: false,
      categories:[],
      wellbeingPillars:[],
      selectedWellbeingPillar:null
    };
  }

  componentDidMount() {
    this.getWellnessGoals();
    this.GetArticleCategories();
    this.getAllWellbeingPillars()
  }

  GetArticleCategories= async () => {

    try {
      const res = await fetchApi(GetArticleCategories,"GET");
      if(res.status === "success"){

        this.setState({categories:res.data});

      }else{
        toast.error(res.message);
      } 
    }
    catch(error){
      window.console.error(error);
    }
   
  }

  getAllWellbeingPillars = async () => {
    // setIsLoading(true);
    try {
      const res = await fetchApi(GetWellbeingPillars , "GET");

      if (res.status === "success") {
        // setWellbeingPillars(res.data);
        this.setState({wellbeingPillars:res?.data})
        // setIsLoading(false);
      } else {
        toast.error(res.data.message || "Something went wrong");
        // setIsLoading(false);s

      }
    } catch (error) {
      window.console.error(error);
      // setIsLoading(false);
    }
  };

  // --- API Helpers ---
  getWellnessGoals = async () => {
    try {
      const res = await fetchApi(`${GetWellnessGoals}`, 'GET');
      if (res.status=== 'success') {
        this.setState({ wellnessGoals: res.data})
      }else{
        toast.error(res.data?.[0])
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  // Fetch questions based on wellness goal category ID (like old code)
  getWBAQuestions = async (categoryId) => {
    this.setState({ isLoadingQuestions: true });
    try {
      const res = await fetchApi(`${GetQuestionByCategoryId + "/" + categoryId}`, 'GET', null, {});
      if (res.status === 'success') {
        // Format questions like old code
        const formattedQuestions = res.data.map((item) => ({
          ...item,
          displayLabel: item.question || item.question_text || `Question ${item.id}`,
          id: item.id,
          name: item.question || item.question_text || `Question ${item.id}`
        }));
        
        this.setState({ 
          wbaQuestions: formattedQuestions,
          showWbaQue: true,
          isLoadingQuestions: false 
        });
      }else{
        toast.error(res?.data?.[0])
      }
    } catch (error) {
      toast.error(this.props.t('Failed to load questions'));
      this.setState({ 
        isLoadingQuestions: false,
        showWbaQue: false 
      });
    }
  }

  // --- Event Handlers ---

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === 'description') {
      this.setState({ charCount: e.target.value.length });
    }
  };

  onChangeImage = (baseImage, imageName) => {
    this.setState({
      image: baseImage,
      imageName: imageName,
      imageUpdated: true,
    });
  };

  onChangeAudio = (e) => {
    const file = e.target.files[0];
    if (file) {
      if ((file.size / 1000000) <= 10) {
        if (file.type === 'audio/mpeg' || file.name.endsWith('.mp3')) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            this.setState({
              audio: reader.result,
              audioName: file.name,
            });
          };
        } else {
          toast.error(this.props.t('Please upload an .mp3 file'));
        }
      } else {
        toast.error(this.props.t('Maximum file size 10 MB'));
      }
    }
  };

  removePhoto = () => {
    this.setState({ image: '', imageName: '' });
  };

  removeAudio = (e) => {
    e.preventDefault();
    this.setState({ audio: '', audioName: '' });
  };

  onChangeArticleContent = (evt) => {
    const newContent = evt.getData();
    this.setState({ description: newContent });
  };

  // Multiple Selection Logic
  onSelectCategory = (item) => {

    this.setState({ journey_category_ids: item.id });
  };


  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  onSelectLevel = (item) => {
    this.setState({ level: item, levelOpen: false });
  };

  onSelectGoal = (item) => {
    // When wellness goal is selected, fetch related questions
    this.setState({ 
      wellness_goal: item, 
      goalOpen: false,
      question: null, // Reset question when goal changes
    }, () => {
      // Fetch questions for this wellness goal
      this.getWBAQuestions(item.id);
    });
  };

  // Question selection handler
  onSelectQuestion = (item) => {
    this.setState({ 
      question: item, 
      questionOpen: false 
    });
  };

  // --- Navigation & Validation ---

  nextStep = () => {
    if (this.isStepValid()) {
      this.setState((prev) => ({ step: prev.step + 1 }));
      window.scrollTo(0, 0);
    } else {
      toast.error(this.props.t('Please fill all mandatory fields'));
    }
  };

  prevStep = () => {
    this.setState((prev) => ({ step: prev.step - 1 }));
    window.scrollTo(0, 0);
  };

  isStepValid = () => {
    const {
      step, title, imageName, journey_category_ids, description
    } = this.state;

    if (step === 1) {
      return title && title.trim() !== '' && imageName;
    }
    if (step === 2) {
      // Validate that the array has at least one item
      return journey_category_ids;
    }
    if (step === 3) {
      // "Type Article" is mandatory. Audio is optional.
      return description && description.trim() !== '';
    }
    return true;
  };

  redirect = () => {

    const{history}=this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";
  
    if (fromAdmin) {
      this.props.history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Articles"});
    } else {
      this.props.history.goBack();
    }
  };

  renderHeading = () => (
    <FormHeading color="#184A61">
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth="32px">{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t('Create Article')}
    </FormHeading>
  );

  // --- Step 1: About Article ---
  renderStepOne = () => {
    const { t } = this.props;
    const {
      title, image, imageUpdated, /*description, charCount,*/
    } = this.state;

    const displayImage = imageUpdated
      ? image
      : (image ? `${ImageUrl}/${image}` : '');

    return (
      <div className="formBody">
        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Article Title')}
            <span>*</span>
          </StyledLabel>
          <StyledInputV2
            placeholder={t('Enter Article title')}
            name="title"
            onChange={this.onChangeInput}
            value={title}
            maxLength="100"
            bgColor="white"
            style={{ background: 'white' }}
            pColor="#BDBDBD"
            color="#184A61"
            border="1px solid #BDBDBD"
          />
          <div className="count">
            {title?.length}
            /100 | C
          </div>
        </InputContainer>

        <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

        <StyledLabel isFont="16px" color="#184A61" margin="0px" marginb="12px" symbolSize="16px">
          {t('Article Thumbnail')}
          <span>*</span>
        </StyledLabel>

        <CommonImageUploader
          imgSrc={displayImage}
          t={t}
          closeIcon={closeIcon}
          UploadIcon={UploadHDMIcon}
          onImageChange={this.onChangeImage}
          onRemoveImage={this.removePhoto}
        />

        <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />

        {/* <InputContainer isColorError={charCount > 3000}>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Article Description')}
            <span>*</span>
          </StyledLabel>
          <StyledTextArea
            name="description"
            placeholder={t('Write your article description here')}
            value={description}
            onChange={this.onChangeInput}
            maxLength={3000}
          />
          <div className="count">
            {charCount}
            /3000 | C
          </div>
        </InputContainer> */}
      </div>
    );
  };

  // --- Step 2: Customize Article ---
  renderStepTwo = () => {
    const { t, /*themesHeaderAll*/ } = this.props;
    const {
      themeId, journey_category_ids, 
      themeOpen, levelOpen, goalOpen, questionOpen,
      level, wellness_goal, question, wellnessGoals, wbaQuestions,
      showWbaQue, isLoadingQuestions, categories, selectedWellbeingPillar,wellbeingPillars
    } = this.state;

    // Create theme options with proper display labels
    // const themeOptions = (themesHeaderAll || []).map((item) => ({
    //   ...item,
    //   displayLabel: `${item.month || ''}, ${item.theme_text || ''}`,
    // }));

    // Create level options with proper display labels
    const levelOptions = WellnessLevels.map((item) => ({
      ...item,
      displayLabel: item.level || '',
    }));

    // Create goal options with proper display labels
    const goalOptions = (wellnessGoals || []).map((item) => ({
      ...item,
      displayLabel: item.name || '',
    }));

    // Questions options from API (filtered by selected wellness goal)
    const questionOptions = wbaQuestions.map((item) => ({
      ...item,
      displayLabel: item.question || item.question_text || item.name || `Question ${item.id}`,
    }));

    return (
      <div className="formBody">
        <StyledLabel isFont="16px" color="#184A61" margin="0px 0px 12px 0px">
          {t('Select category')}
          <span>*</span>
        </StyledLabel>
        <CategoryGrid>
          {categories && categories?.map((cat) => (
            <CategoryChip
              key={cat.id}
              active={journey_category_ids == cat?.id}
              onClick={() => this.onSelectCategory(cat)}
            >
              {cat.image ? (
                <img src={`${ImageUrl}/${cat?.image}`} alt="icon" />
              ) : null}
              {cat?.category_name}
            </CategoryChip>
          ))}
        </CategoryGrid>

        <Border style={{ background: '#EFEFEF', margin: '10px 0' }} />

        {/* Theme Dropdown */}
        <CommonDropdown
          tileContainerStyle={{ width: '100%', padding: '0px 0px 8px 0px' }}
          dropdownStyle={{ top: '90px', zIndex: 10 }}
          labelText={t('Monthly theme')}
          isRequired={false}
          dropdownOpen={themeOpen}
          placeholder={t('Select theme')}
          title={(selectedWellbeingPillar?.pillar_title) ? ` ${getMonthName(selectedWellbeingPillar?.id) + " - " + selectedWellbeingPillar?.pillar_title}` : t('Select theme')}
          id="dropdown-theme"
          onClick={() => this.setState({ 
            themeOpen: !themeOpen, 
            levelOpen: false, 
            goalOpen: false,
            questionOpen: false 
          })}
          data={wellbeingPillars}
          onSelect={this.onSelectTheme}
          active={themeId}
          onSelectParameter={['pillar_title','id']}
          itemValue
          valueIndex={0}
          valueString=""
          dropIcon
          showMonthName={true}
        />

        {/* Level Dropdown */}
        <CommonDropdown
          tileContainerStyle={{ width: '100%', padding: '15px 0px 8px 0px' }}
          dropdownStyle={{ top: '90px', zIndex: 9 }}
          labelText={t('Article Level')}
          isRequired={false}
          dropdownOpen={levelOpen}
          placeholder={t('Select Level')}
          title={level ? t(level.level) : t('Select Level')}
          id="dropdown-level"
          onClick={() => this.setState({ 
            levelOpen: !levelOpen, 
            themeOpen: false, 
            goalOpen: false,
            questionOpen: false 
          })}
          data={levelOptions}
          onSelect={this.onSelectLevel}
          active={level?.id}
          itemValue
          onSelectParameter={['displayLabel']}
          valueString=""
          valueIndex={0}
          dropIcon
          labelMargin="0px"
          fontSize="16px"
        />

        {/* Wellness Goal Dropdown */}
        <CommonDropdown
          tileContainerStyle={{ width: '100%', padding: '15px 0px 8px 0px' }}
          dropdownStyle={{ top: '90px', zIndex: 8 }}
          labelText={t('Wellness Goal')}
          isRequired={false}
          dropdownOpen={goalOpen}
          placeholder={t('Select Goal')}
          title={wellness_goal ? t(wellness_goal.name) : t('Select Goal')}
          id="dropdown-goal"
          onClick={() => this.setState({ 
            goalOpen: !goalOpen, 
            themeOpen: false, 
            levelOpen: false,
            questionOpen: false 
          })}
          data={goalOptions}
          onSelect={this.onSelectGoal}
          active={wellness_goal?.id}
          itemValue
          onSelectParameter={['displayLabel']}
          valueString=""
          valueIndex={0}
          dropIcon
          labelMargin="0px"
          fontSize="16px"
        />

        {/* Question Dropdown - Only shown when wellness goal is selected AND has questions */}
        {showWbaQue && (
          <CommonDropdown
            tileContainerStyle={{ width: '100%', padding: '15px 0px 8px 0px' }}
            dropdownStyle={{ top: '90px', zIndex: 7 }}
            labelText={t('Question (WBA)')}
            isRequired={false}
            dropdownOpen={questionOpen}
            placeholder={isLoadingQuestions ? t('Loading questions...') : t('Select Question')}
            title={question ? (question.question || question.question_text || question.name) : t('Select Question')}
            id="dropdown-question"
            onClick={() => this.setState({ 
              questionOpen: !questionOpen, 
              themeOpen: false, 
              levelOpen: false,
              goalOpen: false 
            })}
            data={questionOptions}
            onSelect={this.onSelectQuestion}
            active={question?.id}
            itemValue
            onSelectParameter={['displayLabel']}
            valueString=""
            valueIndex={0}
            dropIcon
            labelMargin="0px"
            fontSize="16px"
            isLoading={isLoadingQuestions}
          />
        )}
      </div>
    );
  };

  // --- Step 3: Article Content ---
  renderStepThree = () => {
    const { t } = this.props;
    const { /*articleContent,*/ audioName,description } = this.state;

    return (
      <div className="formBody">
        
        {/* Audio Section */}
        <StyledLabel isFont="16px" color="#184A61" margin="0px" marginb="12px" symbolSize="16px">
          {t('Upload Audio File')}
        </StyledLabel>

        {audioName ? (
          <AudioFileContainer>
            <FileName title={audioName}>{audioName}</FileName>
            <CloseIconButton onClick={this.removeAudio} title={t('Remove file')}>
              <CloseIconSVG />
            </CloseIconButton>
          </AudioFileContainer>
        ) : (
          <AudioUploadBox>
            <div style={{ marginBottom: '8px' }}>
              <UploadIconSVG />
            </div>
            <div style={{ color: '#184A61', fontWeight: 'bold' }}>{t('Upload File')}</div>
            <div style={{ color: '#666', fontSize: '12px' }}>{t('(.mp3)')}</div>
            <input
              type="file"
              accept=".mp3,audio/mpeg"
              onChange={this.onChangeAudio}
            />
          </AudioUploadBox>
        )}
        <div style={{ color: '#184A61', fontSize: '12px', marginBottom: '20px' }}>
          {t('Maximum file size 10 MB')}
        </div>

        <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

        {/* Type Article Section */}
        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Type Article')}
            <span>*</span>
          </StyledLabel>
          <EditorContainer>
            <Editor content={description} onChange={this.onChangeArticleContent} placeholder={t('Write description here...')} />
          </EditorContainer>
        </InputContainer>
      </div>
    );
  };

  onSubmit = (e, data) => {
    e.preventDefault();
    // const { addWellnessJourney, history, isAdminRoute } = this.props;

    // Build payload based on form data - MATCHING API EXPECTATIONS
    let payload = {
      title: data?.title,
      description: data?.description, // Short Description
      journey_category_id: data?.journey_category_ids,
      levels: data?.level?.level ? data?.level?.level : null,
      wellness_goal_id: data?.wellness_goal?.id ? data?.wellness_goal?.id : null,
      question_id: data.question && data?.question?.id ? data?.question?.id : null,
      audio_file: data?.audio,
      // audio_name: data.audioName,
      month:data?.selectedWellbeingPillar?.id,
      
      // Image
      image: data?.image,
      // imageName: data.imageName,
      // imageUpdated: data.imageUpdated,
    
    };
    this.createArticle(payload)


  };

  createArticle = async (payload) => {
    const{history}=this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";
    this.setState({ isDisabled: true }); 
    try {
      const res = await fetchApi(AddWellnessJourney , "POST",payload);
      if (res.status === "success") {
        toast.success(res?.data?.[0] || "Article Added Successfully")
        if(fromAdmin){
          history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Articles"});
        }else{
          history.push('/wellness-resources');
        }
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }finally{
      this.setState({ isDisabled: false }); 
    }
  };

  render() {
    const { step, isDisabled } = this.state;
    const { t } = this.props;
    const isValid = this.isStepValid();

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>

            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="article" padding="20px 20px 265px 20px" />
            </div>

            <div className="form">
              <form onSubmit={(e) => { 
                e.preventDefault(); 
                this.setState({ isDisabled: true }); 
                // this.onSubmit(e, this.state); 
              }}>
                {step === 1 && this.renderStepOne()}
                {step === 2 && this.renderStepTwo()}
                {step === 3 && this.renderStepThree()}
              </form>
            </div>
          </Container>

          <ButtonContainer style={{width:'100%', left:'0'}}>
            <Main>
              <div className="wrapper" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                {step > 1 && (
                  <CommonButtonBorder
                    width="200px"
                    height="48px"
                    onClick={this.prevStep}
                    margin="auto auto auto 0px"
                  >
                    {t('Back')}
                  </CommonButtonBorder>
                )}

                {step < 3 && (
                  <CommonButtonPopup
                    height="48px"
                    width="200px"
                    margin={step === 1 ? 'auto 0 auto auto' : 'auto 0 auto auto'}
                    onClick={isValid ? this.nextStep : null}
                    disabled={!isValid}
                    style={{
                      backgroundColor: isValid ? '#DA6C74' : '#EFEFEF',
                      color: isValid ? '#FFFFFF' : '#666666',
                      cursor: isValid ? 'pointer' : 'not-allowed',
                    }}
                  >
                    {t('Next')}
                  </CommonButtonPopup>
                )}

                {step === 3 && (
                  <CommonButtonPopup
                    height="48px"
                    width="200px"
                    margin="auto 0 auto auto"
                    disabled={isDisabled || !isValid}
                    onClick={isValid ? (e) => { 
                      e.preventDefault();
                      // this.setState({ isDisabled: true }); 
                      this.onSubmit(e, this.state); 
                    } : null}
                    style={{
                      backgroundColor: (isDisabled || !isValid) ? '#EFEFEF' : '#DA6C74',
                      color: (isDisabled || !isValid) ? '#666666' : '#FFFFFF',
                      cursor: (isDisabled || !isValid) ? 'not-allowed' : 'pointer',
                    }}
                  >
                    Create Article
                  </CommonButtonPopup>
                )}
              </div>
            </Main>
          </ButtonContainer>
        </div>
      </Layout>
    );
  }
}

CreateArticleForm.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  validationConfig: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  journey_category_id: PropTypes.array,
  t: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  isAdminRoute:PropTypes.bool
};


export default withTranslation()(CreateArticleForm);